import { render, staticRenderFns } from "./ResourceEditForm.vue?vue&type=template&id=3275d0a0&"
import script from "./ResourceEditForm.vue?vue&type=script&lang=js&"
export * from "./ResourceEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports